<template>
  <v-data-table
    :headers="headers"
    :items="filteredList"
    :items-per-page="10"
    class="elevation-1"
    :options="stateOptions"
    @update:options="onUpdate"
    :search="search"
    :custom-filter="customFilter"
    @click:row="onPoiClick"
  >
    <template v-slot:top>
      <v-row
        class="mb-0"
        style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
      >
        <v-col class="d-flex align-center">
          <v-dialog persistent v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-4" small v-on="on">New POI</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="16" sm="6" md="8">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Name"
                        required
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.poiTypeId" label="Poi Type"></v-text-field>
                </v-col>-->
                    <v-col cols="16" sm="6" md="8">
                      <v-select
                        :items="getPoiTypes"
                        v-model="editedItem.poiType"
                        label="Poi Type"
                        item-text="label"
                        item-value="value"
                        required
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="showParentOptions">
                    <v-col cols="16" sm="6" md="4">
                      <v-text-field
                        v-model="
                          $store.state.PoiStore.selectedType.type.parentType
                        "
                        label="Parent Type"
                        outlined
                        :readonly="hasParentProp"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="16" sm="6" md="8">
                      <v-select
                        :items="
                          $store.state.PoiStore.selectedType.availableParents
                        "
                        v-model="editedItem.parentId"
                        label="Select parent"
                        item-text="name"
                        item-value="id"
                        required
                        :readonly="hasParentProp"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="2" sm="2" md="2">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="2" sm="2" md="2">
          <v-select
            :items="getPoiTypesFilter"
            v-model="selectedPoiTypeFilter"
            label="Poi Type"
            item-text="label"
            item-value="value"
            @change="forceSearchUpdate()"
            outlined
            dense
            class="mr-4"
            :hide-details="true"
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.name="{ item }">
      <tr>
        {{
          item.name
        }}
      </tr>
    </template>
    <template v-slot:item.poiTypeId="{ item }">
      {{ getPoiTypeName(item.poiTypeId) }}
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon size="18" class="mr-2">edit</v-icon>
      <v-icon size="24">close</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import Enums from '../../helpers/Enums'
import PoiCard from '../PoiCard'
export default {
  name: 'PoiList',
  props: {
    poiList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    parentType: {
      type: String,
      required: false
    },
    parent: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      enums: Enums,
      headers: [
        { text: 'POI', align: 'left', sortable: true, value: 'name' },
        { text: 'Type', value: 'poiTypeId' },
        { text: 'Actions', value: 'action', sortable: false, align: 'right' }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        poiTypeId: 0,
        parentId: 0,
        clientAppId: 0,
        poiType: null
      },
      defaultItem: {
        name: '',
        poiTypeId: 0,
        parentId: 0,
        clientAppId: 0,
        poiType: null
      },
      dialog: false,
      selectedType: 0,
      showParentOptions: false,
      mounted: false,
      stateOptions: {},
      search: '',
      poiTypes: [
        {
          name: 'all',
          typeId: -1
        }
      ],
      selectedPoiTypeFilter: -1,
      hasParentProp: false,
      defaultPoiIds: [3, 5, 6]
    }
  },
  computed: {
    getPoiTypes() {
      let arr = []
      for (var i = 0; i < this.$store.state.PoiStore.poiTypes.length; i++) {
        let obj = {
          label: this.$t(
            'poiTypes.' + this.$store.state.PoiStore.poiTypes[i].name
          ),
          value: this.$store.state.PoiStore.poiTypes[i].name
        }
        if (
          (this.$store.getters['UserStore/userRole'] !== 'super_admin' ||
            this.$store.getters['UserStore/userRole'] !== 'project_admin') &&
          this.defaultPoiIds.includes(
            this.$store.state.PoiStore.poiTypes[i].typeId
          )
        ) {
          continue
        } else {
          arr.push(obj)
        }
      }
      return arr
    },

    getPoiTypesFilter() {
      let arr = [
        {
          label: 'All',
          value: -1
        }
      ]

      for (var i = 0; i < this.$store.state.PoiStore.poiTypes.length; i++) {
        let obj = {
          label: this.$t(
            'poiTypes.' + this.$store.state.PoiStore.poiTypes[i].name
          ),
          value: this.$store.state.PoiStore.poiTypes[i].typeId
        }
        if (
          (this.$store.getters['UserStore/userRole'] !== 'super_admin' ||
            this.$store.getters['UserStore/userRole'] !== 'project_admin') &&
          this.defaultPoiIds.includes(
            this.$store.state.PoiStore.poiTypes[i].typeId
          )
        ) {
          continue
        } else {
          arr.push(obj)
        }
      }
      return arr
    },

    formTitle() {
      return this.editedIndex === -1 ? 'New Poi' : 'Edit Poi'
    },
    filteredList() {
      return this.poiList.filter(this.filterType)
    }
  },
  watch: {
    dialog(val) {
      if (val && !this.editedItem.poiType) {
        if (
          this.$store.getters['UserStore/userRole'] !== 'super_admin' ||
          this.$store.getters['UserStore/userRole'] !== 'project_admin'
        ) {
          if (this.parentType === 'masterplan') {
            this.editedItem.poiType = 'poi-type-masterplan-info'
          } else if (this.parentType === 'building') {
            this.editedItem.poiType = 'poi-type-building-info'
          } else if (this.parentType === 'apartment') {
            this.editedItem.poiType = 'poi-type-apartment-info'
          }
        }
      }
      val || this.close()
    },

    'editedItem.poiType': function() {
      this.editedItem.poiTypeId = this.enums.PoiType[
        this.editedItem.poiType.replaceAll('-', '_')
      ]
    }
  },
  beforeCreate: function() {
    // let parentType = "";
    // if (this.$route.params.buildingId) parentType = "building";
    // else if (this.$route.params.masterplanId) parentType = "masterplan";
  },
  created: async function() {
    if (this.parent && this.parentType) {
      this.hasParentProp = true

      await this.$store.dispatch('PoiStore/fetchPoiTypes', this.parentType)
      this.poiTypes = this.$store.state.PoiStore.poiTypes
      await this.$store.dispatch('PoiStore/setSelectedType', this.parentType)
      this.editedItem.parentId = this.parent.id
    } else {
      await this.$store.dispatch('PoiStore/resetStore')
      await this.$store.dispatch('PoiStore/fetchPoiTypes')
      this.poiTypes = this.poiTypes.concat(this.$store.state.PoiStore.poiTypes)
      this.showParentOptions = false
    }
    this.stateOptions = localStorage.poiListOptions
      ? JSON.parse(localStorage.poiListOptions)
      : {}
  },
  mounted: async function() {
    this.mounted = true
    if (this.parent && this.parentType) {
      this.hasParentProp = true
      await this.$store.dispatch('PoiStore/fetchPoiTypes', this.parentType)
      this.poiTypes = this.$store.state.PoiStore.poiTypes
      this.editedItem.parentId = this.parent.id
    } else {
      await this.$store.dispatch('PoiStore/fetchPoiTypes')
      this.poiTypes = this.poiTypes.concat(this.$store.state.PoiStore.poiTypes)
      this.showParentOptions = true
    }
    this.stateOptions = localStorage.poiListOptions
      ? JSON.parse(localStorage.poiListOptions)
      : {}
  },
  methods: {
    onUpdate(value) {
      if (this.mounted) {
        localStorage.poiListOptions = JSON.stringify(value)
      }
    },
    customFilter(value, search, item) {
      return new RegExp(search, 'i').test(item.name)
    },
    forceSearchUpdate() {},
    filterType(poi) {
      if (
        !(
          this.$store.getters['UserStore/userRole'] === 'super_admin' ||
          this.$store.getters['UserStore/userRole'] === 'project_admin'
        ) &&
        this.defaultPoiIds.includes(poi.poiTypeId)
      ) {
        return false
      }

      if (
        this.selectedPoiTypeFilter == -1 ||
        poi.poiTypeId == this.selectedPoiTypeFilter
      ) {
        return true
      }

      return false
    },

    async onPoiClick(poi) {
      //this.$router.push(this.$route.path + "/pois/" + poiId);
      await this.$store.dispatch('PoiStore/setSelectedPoi', poi.id)
      await this.$store.dispatch(
        'BreadcrumbsStore/add',
        {
          text: 'P.O.I ',
          name: poi.name
        },
        { root: true }
      )
      await this.$store.dispatch('BreadcrumbsStore/setShortNavigation')
      this.$store.dispatch('MediaStore/setMediaContext', 'poi')
      this.$router.push('/pois/' + poi.id).catch(err => {})
    },
    editItem(item) {
      this.editedIndex = this.poiList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.handlePoiTypeChange(this.editedItem.poiTypeId)
      this.dialog = true
      this.showParentOptions = true
    },

    deleteItem(item, e) {
      e.stopPropagation()
      this.$store.dispatch('DialogStore/open', {
        title: 'Delete poi',
        header: false,
        subtitle: 'Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItemAction(item)
        },
        cancelText: 'Cancel'
      })
    },
    deleteItemAction(item) {
      const index = this.poiList.indexOf(item)
      this.$store.dispatch('PoiStore/deletePoi', item.id).then(res => {
        this.poiList.splice(index, 1)
      })
    },

    close() {
      this.dialog = false

      if (!this.hasParentProp) {
        setTimeout(() => {
          this.showParentOptions = false
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    },

    save() {
      if (
        this.editedItem.name == '' ||
        this.editedItem.poiTypeId == 0 ||
        this.editedItem.parentId == 0
      ) {
        this.$store.dispatch(
          'NotificationStore/add',
          { type: 'error', message: `All fields are required.` },
          { root: true }
        )
      } else if (this.editedIndex > -1) {
        //UPDATE
        //Object.assign(this.buildingList[this.editedIndex], this.editedItem);
        this.$store
          .dispatch('PoiStore/updatePoi', this.editedItem)
          .then(res => {
            this.$store.dispatch('PoiStore/fetchPois')
            // if (this.$route.params.buildingId) {
            //   this.$store.dispatch(
            //     "BuildingStore/setSelectedBuilding",
            //     this.$route.params.buildingId
            //   );
            // } else {
            //   this.$store.dispatch(
            //     "MasterplanStore/setSelectedMasterplan",
            //     this.$store.state.MasterplanStore.selectedMasterplan.id
            //   );
            // }
          })
      } else {
        //CREATE
        //this.buildingList.push(this.editedItem);
        // if (this.$route.params.buildingId)
        //   this.editedItem.parentId = this.$route.params.buildingId;
        // else if (this.$route.params.masterplanId)
        //   this.editedItem.parentId = this.$route.params.masterplanId;
        this.editedItem.clientAppId = this.$store.state.ClientAppStore.selectedApp.id
        this.$store
          .dispatch('PoiStore/createPoi', this.editedItem)
          .then(res => {
            this.$store.dispatch('PoiStore/fetchPois')
            // if (this.$route.params.buildingId) {
            //   this.$store.dispatch(
            //     "BuildingStore/setSelectedBuilding",
            //     this.$route.params.buildingId
            //   );
            // } else {
            //   this.$store.dispatch(
            //     "MasterplanStore/setSelectedMasterplan",
            //     this.$store.state.MasterplanStore.selectedMasterplan.id
            //   );
            // }
          })
        //this.showParentOptions = false
      }
      this.close()
    },
    getPoiTypeName(poiTypeId) {
      let type
      this.$store.state.PoiStore.poiTypes.forEach(element => {
        if (element.typeId == poiTypeId) type = element
      })
      return type ? this.$t('poiTypes.' + type.name) : ''
    },
    handlePoiTypeChange(typeId) {
      let selectedType = this.$store.state.PoiStore.poiTypes.find(item => {
        return item.typeId === typeId
      })
      this.$store
        .dispatch('PoiStore/setSelectedType', selectedType)
        .then(res => {
          // this.availableParents = this.$store.state.PoiStore.selectedType.availableParents;
          this.showParentOptions = true
        })
    }
  }
  // handlePoiClick(poiId) {
  //   this.$store
  //     .dispatch("PoiStore/setSelectedPoi", poiId, { root: true })
  //     .then(res => {
  //       this.$store
  //         .dispatch("MediaStore/fetchMediaForPoi", { root: true })
  //         .then(res => {
  //           this.$router.push("/media");
  //         });
  //     });
  // }
}
</script>

<style scoped></style>
